/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [tooltip-badge.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 25.02.20, 15:12
 */

import React from 'react';
import {AvatarFlatAnchor} from "../navigation/links/nav-headlines";
import {ReactionInfo} from "./like-reaction-info";
import {HtmlTooltipContent} from "../navigation/buttons/nav-buttons";
import {Lens} from "@material-ui/icons";
import {useLanguage} from "../configuration/configuration";

const LikeBadgedIcon = ({count}) => {
    return <div className='like-badged-icon'>
        <Lens fontSize='large' className="like-icon"/>
        <div className='like-count'>{count}</div>
    </div>
}

// component displays likes for posts and comments in a tooltip
const LikeNavigationTooltip = ({reaction, likes}) => {
    const Lang = useLanguage();
    const reactionInfo = ReactionInfo(Lang);

    const renderTooltipEntries = (reaction, likes) => {
        const entries = likes.map(like => {
            return <AvatarFlatAnchor key={like.id} className='mb-1 d-block'
                                     user={like.user}
                                     href={`/${like.user.username}/home`}>
                {like.user.fullname}
            </AvatarFlatAnchor>
        });

        return <div className='like-navigation-tooltip'>
            <div className="like-navigation-tooltip-title">
                {reactionInfo[reaction]}
            </div>
            <ul className='like-navigation-tooltip-list'>
                {entries}
            </ul>
        </div>
    };

    if (!likes || likes.length === 0) return null;
    return <HtmlTooltipContent html={renderTooltipEntries(reaction, likes)}
                               htmlParams={{interactive: true}}>
        <LikeBadgedIcon count={likes.length}/>
    </HtmlTooltipContent>
};

export default LikeNavigationTooltip;